export default "__VITE_ASSET__af6f7c83__"